import { NO, YES } from 'src/utils/constants/stringConstants';

import { useAppStore } from 'src/hooks/useAppStore';
import { colors } from '../../../styles/colors';
import Button from '../../buttons/Button';
import Modal from '../../modal/Modal';
import { handleCloseMixpanelEvent } from '../SearchMixpanelHelper';
import {
  noButtonStyle,
  popupContainer,
  popupDescStyle,
  popupTitleStyle,
  yesButtonStyle
} from './RemoveAllPopupStyle';

type RemoveAllPopupPropType = {
  showClearAllPopup: boolean;
  clearAllRecentSearchData: (e: React.MouseEvent) => void;
  setClearAllPopup: (showClearAllPopup: boolean) => void;
  setSearchFocus: (searchFocus: boolean) => void;
  setHideMenu?: (hideMenu: boolean) => void;
  setEnableSearchBox?: (enableSearchBox: boolean) => void;
};

const RemoveAllPopup = ({
  showClearAllPopup,
  clearAllRecentSearchData,
  setClearAllPopup,
  setSearchFocus,
  setHideMenu,
  setEnableSearchBox
}: RemoveAllPopupPropType) => {
  const { translations } = useAppStore();
  const {
    search_landing_clear_all_warning_message_header_text,
    search_landing_clear_all_warning_message_subheader_text
  } = translations?.common || {};

  const closeHandler = (closeButton = false) => {
    setClearAllPopup(false);
    handleCloseMixpanelEvent(closeButton);
  };
  return (
    <Modal
      show={showClearAllPopup}
      onClose={() => closeHandler()}
      width="450px"
      height="275px"
      background={colors.white}
      renderCloseIcon={true}
      closeIconColor={colors.black}
      padding="5px">
      <div css={popupContainer} data-testid="remove-all-container">
        <div css={popupTitleStyle}>
          {search_landing_clear_all_warning_message_header_text}
        </div>
        <div css={popupDescStyle}>
          {search_landing_clear_all_warning_message_subheader_text}
        </div>
        <Button
          customStyles={yesButtonStyle}
          callback={(e) => clearAllRecentSearchData(e)}>
          <div data-testid="yes-btn">{YES}</div>
        </Button>
        <Button
          customStyles={noButtonStyle}
          callback={() => closeHandler(true)}>
          <div data-testid="no-btn">{NO}</div>
        </Button>
      </div>
    </Modal>
  );
};

export default RemoveAllPopup;
